import React, {Component} from 'react';
import {
  Navbar,
  Collapse,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import OnboardingStepIndicator from './OnboardingStepIndicator';

class OnboardingNavBar extends Component {
  render(){
    const { navHidden, hidden, currentStep } = this.props;

    return (
      <Navbar
        toggleable
        style={{
          padding:'0px 30px 0px 30px',
          color:'#101010',
          borderBottom:navHidden ? '':'1px solid #e4e4e4',
          visibility:hidden ? 'hidden' : 'visible',
          height:70
        }}
        className='HorizontalNavBar no-print'
      >
        <NavbarBrand>
          <img
            src={require('../../../shared/assets/dd-logo.png')}
            alt='Adjoy'
            style={{
              height:30,
              marginRight:10
            }}
          />
        </NavbarBrand>
        {!navHidden && (
          <Collapse navbar isOpen>
            <Nav navbar style={{paddingLeft:30}}>
              <OnboardingStepIndicator
                number={1}
                name='Create Experience'
                active={currentStep === 1}
                completed={currentStep > 1}
              />
              <OnboardingStepIndicator
                number={2}
                name='Audience'
                active={currentStep === 2}
                completed={currentStep > 2}
              />
              <OnboardingStepIndicator
                number={3}
                name='Payment Method'
                active={currentStep === 3}
                completed={currentStep > 3}
              />
              <OnboardingStepIndicator
                number={4}
                name='Review & Submit'
                active={currentStep === 4}
                completed={currentStep > 4}
              />
            </Nav>
            <Nav className="ml-auto" navbar>
              <NavItem className='NonUserNameNavItem'>
                <NavLink
                  tag={Link}
                  to='/welcome/help/faqs'
                  activeClassName='active'
                >
                  &nbsp;&nbsp;Help
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        )}
      </Navbar>
    )
  }
}

export default OnboardingNavBar;



// WEBPACK FOOTER //
// ./src/routes/OnboardingPortal/components/OnboardingNavBar.js